<template>
    <div class="content"> 
        <component v-if="this.currentComponent" :is="this.currentComponent" />
        <div v-if="this.showHallOfFame">
            <HallOfFameView />
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import HallOfFameView from './HallOfFameView.vue';
import EventBus from "../eventBus.js"
import axios from "axios"
import { useToast } from "vue-toastification"

export default {
    components: { HallOfFameView },
    data() {
        return {
            currentComponent: null,
            showHallOfFame: true
        }
    },

    created() {
        const toast = useToast();
        EventBus.on("pass", ({profile, auth_token}) => {
            this.$cookies.remove("trin");

            toast.success("Korrekt gæt!");

            if (profile.trin == 26) {
                this.win();
            } else {
                EventBus.emit("update-profile", {
                    profile: profile, 
                    auth_token: auth_token
                });
                EventBus.emit("load-view");
            }
        });

        EventBus.on("load-view", () => {
            this.loadView(true);
        });

        EventBus.on("login-profile", () => {
            this.loadView(true);
        });

        EventBus.on("logout-profile", () => {
            this.currentComponent = null
        });

        this.loadView(false);
    },
    methods: {
        async win() {
            this.$cookies.remove("trin");

            try {
                const response = await axios.post("/win")
                if (response.status == 200) {
                    EventBus.emit("update-profile", {
                        profile: response.data.profile, 
                        auth_token: response.data.authorization.auth_token
                    });
                    EventBus.emit("load-view");
                }
            } catch (err) {
                console.error(err)
            }
        },
        loadView(isReload) {
            const storedProfile = localStorage.getItem("profile");
            
            if (storedProfile) {
                this.showHallOfFame = false;

                let trin = JSON.parse(storedProfile).trin;
                const currentTrin = this.$cookies.get("trin");
                if (currentTrin != null) {
                    if ((trin == -1 || trin > currentTrin) && currentTrin > 0) {
                        trin = currentTrin;
                    } 
                    
                    if (currentTrin > 25) {
                        this.$cookies.set("trin", trin);
                    }

                    if (currentTrin == -1) {
                        this.currentComponent = HallOfFameView;
                        return;
                    }
                }

                if (trin > 25) {
                    // recursive calling, but hopefully no error occurs
                    this.win();
                    return;
                }
                if (trin == -1 && currentTrin == null) {
                    this.currentComponent = HallOfFameView;
                    return;
                }
                // otherwise load trin
                try {
                    this.currentComponent = defineAsyncComponent({
                        loader: () => import(`../trin/KTrin${trin}.vue`),
                        loadingComponent: { template: '<div>Indlæser...</div>' },
                        errorComponent: { template: '<div>Fejl: kunne ikke indlæse vindue</div>' },
                        delay: 150,
                        timeout: 20000
                    });
                } catch (err) {
                    console.error(err)
                }
            } else {
                this.showHallOfFame = true;
            }

            if (isReload) {
                this.$forceUpdate();
            }
        }
    }
}
</script>

<style scoped>
    .content {
        font-size: 20px;
        top: 250px;
        position: relative;
    }
</style>
